export enum SurveyDispatchEvent {
  SHOW_SURVEY = 'SHOW_SURVEY',
  DISMISS_SURVEY = 'DISMISS_SURVEY',
  SUBMIT_SURVEY = 'SUBMIT_SURVEY',
}
